<template>
  <header class="navbar">
    <button
      @click="toggleSidebarCollapsed"
      class="sidebar-toggle-btn"
      :class="{ 'sidebar-collapsed': isSidebarCollapsed }"
      :title="
        isSidebarCollapsed ? 'Étendre la sidebar' : 'Rétracter la sidebar'
      "
    >
      <i class="fas fa-bars"></i>
    </button>

    <div class="navbar-nav">
      
      <button
        @click="router.push({ name: 'catalog/mel' })"
        class="navbar-btn-secondary"
      >
        <i class="fas fa-plus" style="font-size: 0.95em;"></i>
        <span>Créer un produit</span>
      </button>

      <div class="navbar-seller-name">
        <span class="text-black">{{
          isLoading ? "Chargement..." : vendeurData.nomSociete
        }}</span>
        <span
          v-if="adminOrderShopName"
          class="navbar-seller-shop-name text-black"
        >
          ({{ adminOrderShopName }})
        </span>
      </div>

      <div class="navbar-dropdown" ref="dropdownRef">
        <button
          class="navbar-dropdown-toggle"
          @click="toggleDropdown"
          :aria-expanded="isDropdownOpen"
        >
          <i class="fas fa-user"></i>
        </button>
        <ul
          class="navbar-dropdown-menu"
          :class="isDropdownOpen ? 'is-open' : 'is-closed'"
        >
          <li v-if="isLoading" class="dropdown-loading">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Chargement des informations...</span>
          </li>
          <template v-else>
            <!-- Informations personnelles -->
            <li class="dropdown-section-title">
              <i class="fas fa-user-circle"></i>
              <span>Informations personnelles</span>
            </li>

            <li class="dropdown-item">
              <i class="fas fa-envelope"></i>
              <div class="dropdown-item-content">
                <span class="dropdown-item-label">Email</span>
                <span class="dropdown-item-value">{{ vendeurData.email }}</span>
              </div>
            </li>

            <li class="dropdown-item">
              <i class="fas fa-phone"></i>
              <div class="dropdown-item-content">
                <span class="dropdown-item-label">Téléphone fixe</span>
                <span class="dropdown-item-value">{{
                  vendeurData.telephone
                }}</span>
              </div>
            </li>

            <li class="dropdown-item">
              <i class="fas fa-mobile-alt"></i>
              <div class="dropdown-item-content">
                <span class="dropdown-item-label">Téléphone mobile</span>
                <span class="dropdown-item-value">{{
                  vendeurData.mobile
                }}</span>
              </div>
            </li>

            <li class="dropdown-item">
              <i class="fas fa-map-marker-alt"></i>
              <div class="dropdown-item-content">
                <span class="dropdown-item-label">Adresse</span>
                <span class="dropdown-item-value"
                  >{{ vendeurData.adresse }} ,
                  {{ vendeurData.code_postal }} {{ vendeurData.ville }}</span
                >
              </div>
            </li>

            <!-- Liens utiles -->
            <li class="dropdown-section-title">
              <i class="fas fa-external-link-alt"></i>
              <span>Liens utiles</span>
            </li>
            <li v-if="vendeurPageUrl" class="dropdown-item">
              <i class="fas fa-store"></i>
              <a :href="vendeurPageUrl" target="_blank">Voir ma page</a>
            </li>
            <li class="dropdown-item">
              <i class="fas fa-headset"></i>
              <a href="#" @click="emit('show-contact-modal')">Contactez nous</a>
            </li>
            <li class="dropdown-item">
              <i class="fas fa-book"></i>
              <a
                href="https://knowledge.efashion-paris.com/vendors"
                target="_blank"
                >Guide Efashion</a
              >
            </li>
            <li class="dropdown-item">
              <i class="fas fa-file-contract"></i>
              <a
                href="https://landingpage.efashion-paris.com/fr/conditions-g%C3%A9n%C3%A9rales-dutilisation-grossistes-vendeurs"
                target="_blank"
                >CGUV</a
              >
            </li>

            <!-- Séparateur -->
            <li class="dropdown-divider"></li>

            <!-- Logout -->
            <li class="dropdown-item dropdown-logout" @click="seDeconnecter">
              <i class="fas fa-sign-out-alt"></i>
              <a href="#">Déconnexion</a>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <!-- Navbar MOBILE -->
    <div class="navbar-mobile-container">
      <button
        type="button"
        @click="toggleSidebar"
        aria-controls="sidebarMenu"
        :aria-expanded="isSidebarOpen"
        aria-label="Toggle navigation"
        class="navbar-mobile-burger"
      >
        <i class="fas fa-bars"></i>
      </button>
      <ul class="navbar-mobile-buttons">
        <li>
          <div class="navbar-dropdown" ref="dropdownMobileRef">
            <button
              class="navbar-dropdown-toggle"
              @click="toggleDropdownMobile"
              :aria-expanded="isDropdownMobileOpen"
            >
              <i class="fas fa-user"></i>
            </button>
            <ul
              class="navbar-dropdown-menu"
              :class="isDropdownMobileOpen ? 'is-open' : 'is-closed'"
            >
              <li v-if="isLoading" class="dropdown-loading">
                <i class="fas fa-spinner fa-spin"></i>
                <span>Chargement des informations...</span>
              </li>
              <template v-else>
                <!-- Informations personnelles -->
                <li class="dropdown-section-title">
                  <i class="fas fa-user-circle"></i>
                  <span>Informations personnelles</span>
                </li>

                <li class="dropdown-item">
                  <i class="fas fa-envelope"></i>
                  <div class="dropdown-item-content">
                    <span class="dropdown-item-label">Email</span>
                    <span class="dropdown-item-value">{{
                      vendeurData.email
                    }}</span>
                  </div>
                </li>

                <li class="dropdown-item">
                  <i class="fas fa-phone"></i>
                  <div class="dropdown-item-content">
                    <span class="dropdown-item-label">Téléphone fixe</span>
                    <span class="dropdown-item-value">{{
                      vendeurData.telephone
                    }}</span>
                  </div>
                </li>

                <li class="dropdown-item">
                  <i class="fas fa-mobile-alt"></i>
                  <div class="dropdown-item-content">
                    <span class="dropdown-item-label">Téléphone mobile</span>
                    <span class="dropdown-item-value">{{
                      vendeurData.mobile
                    }}</span>
                  </div>
                </li>

                <li class="dropdown-item">
                  <i class="fas fa-map-marker-alt"></i>
                  <div class="dropdown-item-content">
                    <span class="dropdown-item-label">Adresse</span>
                    <span class="dropdown-item-value"
                      >{{ vendeurData.adresse }} ,
                      {{ vendeurData.code_postal }} {{ vendeurData.ville }}</span
                    >
                  </div>
                </li>

                <!-- Liens utiles -->
                <li class="dropdown-section-title">
                  <i class="fas fa-external-link-alt"></i>
                  <span>Liens utiles</span>
                </li>
                <li class="dropdown-item">
                  <i class="fas fa-headset"></i>
                  <a
                    href="#"
                    @click="
                      () => {
                        isDropdownMobileOpen = false;
                        emit('show-contact-modal');
                      }
                    "
                    >Contactez nous</a
                  >
                </li>
                <li class="dropdown-item">
                  <i class="fas fa-book"></i>
                  <a
                    href="https://knowledge.efashion-paris.com/vendors"
                    target="_blank"
                    >Guide Efashion</a
                  >
                </li>
                <li class="dropdown-item">
                  <i class="fas fa-file-contract"></i>
                  <a
                    href="https://landingpage.efashion-paris.com/fr/conditions-g%C3%A9n%C3%A9rales-dutilisation-grossistes-vendeurs"
                    target="_blank"
                    >CGUV</a
                  >
                </li>

                <!-- Séparateur -->
                <li class="dropdown-divider"></li>

                <!-- Logout -->
                <li
                  class="dropdown-item dropdown-logout"
                  @click="
                    () => {
                      isDropdownMobileOpen = false;
                      seDeconnecter();
                    }
                  "
                >
                  <i class="fas fa-sign-out-alt"></i>
                  <a href="#">Déconnexion</a>
                </li>
              </template>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getVendeurGeneralInfo } from "@/api/vendeur";
import { useAuthStore } from "@/stores/auth";
import type { NavbarProps, NavbarEmits } from "@/types";

defineProps<NavbarProps>();
const emit = defineEmits<NavbarEmits>();

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();


const isDashboardRoute = computed(() => {
  return route.path.startsWith("/dashboard");
});

// Génère un slug URL-friendly à partir d'une chaîne
const getSlug = (str: string): string => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Supprime les accents
    .replace(/[^a-z0-9]+/g, "-") // Remplace les caractères spéciaux par des tirets
    .replace(/^-+|-+$/g, ""); // Supprime les tirets en début/fin
};

// URL de la page vendeur
const vendeurPageUrl = computed(() => {
  const nomBoutique = vendeurData.value.nomBoutique;
  const idVendeur = vendeurData.value.id_vendeur;
  if (!nomBoutique || !idVendeur) return "";
  const slug = getSlug(nomBoutique);
  return `https://www.efashion-paris.com/vendeurs/${slug}-${idVendeur}.html`;
});

// Dropdown
const dropdownRef = ref<HTMLElement | null>(null);
const dropdownMobileRef = ref<HTMLElement | null>(null);
const isDropdownOpen = ref(false);
const isDropdownMobileOpen = ref(false);

const handleClickOutside = (event: Event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isDropdownOpen.value = false;
  }
  if (
    dropdownMobileRef.value &&
    !dropdownMobileRef.value.contains(event.target as Node)
  ) {
    isDropdownMobileOpen.value = false;
  }
};

const DEFAULT_VENDEUR = {
  nomSociete: "non disponible",
  email: "non disponible",
  telephone: "non disponible",
  mobile: "non disponible",
  adresse: "non disponible",
  code_postal: "non disponible",
  ville: "non disponible",
  nomBoutique: "",
  id_vendeur: 0,
};

const isLoading = ref(true);
const vendeurData = ref({ ...DEFAULT_VENDEUR });
const hasCurrentAddressCache = ref(false);

const adminOrderShopName = computed(() => {
  if (
    !authStore.isImpersonating ||
    route.name !== "orderdetails-detail" ||
    !vendeurData.value.nomBoutique
  ) {
    return "";
  }

  const companyName = vendeurData.value.nomSociete.trim().toLocaleLowerCase();
  const shopName = vendeurData.value.nomBoutique.trim();

  return shopName.toLocaleLowerCase() === companyName ? "" : shopName;
});

const LOCAL_STORAGE_KEY = "vendeur_info_header";

const loadFromStorage = () => {
  const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!raw) {
    isLoading.value = false;
    return;
  }

  try {
    const saved = JSON.parse(raw) as Partial<typeof DEFAULT_VENDEUR>;
    hasCurrentAddressCache.value = Object.prototype.hasOwnProperty.call(
      saved,
      "ville",
    );
    vendeurData.value = {
      ...DEFAULT_VENDEUR,
      ...saved,
    };
  } catch (e) {
    // Erreur silencieuse - les infos vendeur restent vides
  } finally {
    isLoading.value = false;
  }
};

//save grossiste info into local storage and state
const fetchVendeurInfo = async () => {
  const profile = await getVendeurGeneralInfo();

  const storeAddress = profile.adresses?.find((addr: any) => addr.type === 2);

  const newData = {
    nomSociete: profile.nomSociete || profile.nomBoutique || "non disponible",
    email: profile.email || "non disponible",
    telephone: storeAddress?.telephone || "non disponible",
    mobile: storeAddress?.mobile || "non disponible",
    adresse: storeAddress?.adresse || "non disponible",
    code_postal: storeAddress?.codePostal || "non disponible",
    ville: storeAddress?.ville || "non disponible",
    nomBoutique: profile.nomBoutique || "",
    id_vendeur: profile.id_vendeur || 0,
  };

  vendeurData.value = newData;
  hasCurrentAddressCache.value = true;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
};

const refreshFromApiIfNeeded = async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth();
  }

  if (!authStore.isAuthenticated) return;

  const authVendeurId = authStore.user?.id_vendeur ?? authStore.user?.id;
  const cachedId = vendeurData.value.id_vendeur;

  // Ne pas recharger que si le cache correspond au vendeur authentifié
  if (
    vendeurData.value.nomBoutique &&
    hasCurrentAddressCache.value &&
    cachedId &&
    authVendeurId &&
    cachedId === authVendeurId
  ) {
    return;
  }

  isLoading.value = true;
  try {
    await fetchVendeurInfo();
  } catch (error) {
    // Erreur silencieuse - les infos vendeur n'ont pas été chargées
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);

  loadFromStorage();

  void refreshFromApiIfNeeded();
});

watch(
  () => route.path,
  () => {
    void refreshFromApiIfNeeded();
  },
);

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

const toggleSidebarCollapsed = () => {
  emit("toggle-sidebar-collapsed");
};

const toggleSidebar = () => {
  emit("toggle-sidebar");
};

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const toggleDropdownMobile = () => {
  isDropdownMobileOpen.value = !isDropdownMobileOpen.value;
};

function seDeconnecter() {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
  authStore.logout();
}
</script>

<style lang="scss" scoped>
.navbar-seller-name {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}

.navbar-seller-shop-name {
  margin-top: 0.125rem;
  font-size: 0.75rem;
}

/* Hide the top navbar when printing the recap (remove 图二 on paper) */
@media print {
  .navbar {
    display: none !important;
  }
}

</style>
